import _VolumeUp from "@mui/icons-material/VolumeUp";
import _VolumeOff from "@mui/icons-material/VolumeOff";
import React from 'react';
import { ButtonContainer, IconButtonLabel, IconButtonWrapper, withDisabledIcon, withDropShadow } from 'app/components/tv/customControls/SharedCustomControlsStyles';
const VolumeOffIconShadow = withDropShadow(_VolumeOff);
const VolumeOffIconDisabled = withDropShadow(withDisabledIcon(_VolumeOff));
const VolumeUpIconShadow = withDropShadow(_VolumeUp);
const MuteIcon = _ref => {
  let {
    forceMuted,
    labeled,
    muted
  } = _ref;
  if (forceMuted) {
    return /*#__PURE__*/React.createElement(VolumeOffIconDisabled, null);
  }
  if (muted) {
    return labeled ? /*#__PURE__*/React.createElement(VolumeOffIconShadow, null) : /*#__PURE__*/React.createElement(_VolumeOff, null);
  }
  return labeled ? /*#__PURE__*/React.createElement(VolumeUpIconShadow, {
    "data-sentry-element": "VolumeUpIconShadow",
    "data-sentry-component": "MuteIcon",
    "data-sentry-source-file": "MuteToggle.tsx"
  }) : /*#__PURE__*/React.createElement(_VolumeUp, {
    "data-sentry-element": "VolumeUp",
    "data-sentry-component": "MuteIcon",
    "data-sentry-source-file": "MuteToggle.tsx"
  });
};
export const MuteToggle = _ref2 => {
  let {
    muted,
    toggleMute,
    forceMuted,
    labeled
  } = _ref2;
  const ToggleButton = /*#__PURE__*/React.createElement(ButtonContainer, {
    onClick: toggleMute,
    disabled: forceMuted,
    title: muted ? 'Stummschaltung aufheben' : 'Stummschalten'
  }, /*#__PURE__*/React.createElement(MuteIcon, {
    muted: muted,
    forceMuted: forceMuted,
    labeled: labeled
  }));
  if (!labeled) {
    return ToggleButton;
  }
  return /*#__PURE__*/React.createElement(IconButtonWrapper, {
    "data-sentry-element": "IconButtonWrapper",
    "data-sentry-component": "MuteToggle",
    "data-sentry-source-file": "MuteToggle.tsx"
  }, ToggleButton, /*#__PURE__*/React.createElement(IconButtonLabel, {
    $disabled: forceMuted,
    variant: "body1",
    "data-sentry-element": "IconButtonLabel",
    "data-sentry-source-file": "MuteToggle.tsx"
  }, "Stumm"));
};